import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import fetchApi from '../utils/api.js';
import Swal from 'sweetalert2';

const InvoiceTypeForm = ({ isOpen, onClose, invoiceType, isPage }) => {
    const [name, setName] = useState('');
    const [companyId, setCompanyId] = useState('');
    const [companies, setCompanies] = useState([]);
    const [userRole, setUserRole] = useState('');

    useEffect(() => {
        const userStr = sessionStorage.getItem('user');
        if (userStr) {
            const user = JSON.parse(userStr);
            setUserRole(user.role);
            if (user.role === 'SUPER_ADMIN' && isOpen) {
                fetchCompanies();
            }
        }
    }, [isOpen]);

    useEffect(() => {
        if (invoiceType) {
            setName(invoiceType.invoiceTypeName || invoiceType.invoice_type_name || '');
            const cid = invoiceType.companyId?._id || invoiceType.companyId || invoiceType.company_id;
            setCompanyId(cid ? cid : 'all');
        } else {
            setName('');
            setCompanyId('');
        }
    }, [invoiceType]);

    const fetchCompanies = async () => {
        try {
            const data = await fetchApi('/company');
            setCompanies(data.companies || data);
        } catch (error) {
            console.error('Error fetching companies:', error);
        }
    };

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        const conf = await Swal.fire({
            title: 'Save Data?',
            text: 'Are you sure you want to save this data?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#00334e',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Save',
            cancelButtonText: 'No, Keep Editing'
        });
        if (!conf.isConfirmed) return;

        const trimmedName = name.trim();
        if (!trimmedName) {
            toast.error("Name is required");
            return;
        }

        const isSuperAdmin = userRole === 'SUPER_ADMIN';
        if (isSuperAdmin && !companyId) {
            toast.error("Company selection is required");
            return;
        }

        try {
            const id = invoiceType?._id || invoiceType?.id;
            const endpoint = invoiceType
                ? `/invoice-type/${id}`
                : '/invoice-type';
            const method = invoiceType ? 'PUT' : 'POST';

            const payload = {
                invoice_type_name: trimmedName,
                ...(isSuperAdmin && { company_id: companyId })
            };

            await fetchApi(endpoint, {
                method,
                body: JSON.stringify(payload)
            });

            toast.success(invoiceType ? "Invoice Type Updated Successfully" : "Invoice Type Added Successfully");
            onClose();
        } catch (error) {
            console.error('Save Error:', error);
            toast.error(error.message || "Failed to save");
        }
    };

    if (!isOpen) return null;

    return (
        <div className={isPage ? "list-page-container" : "modal-overlay"}>
            <div className={isPage ? "" : "modal"}>
                <div className="modal-header">
                    <h2 className="modal-title">{invoiceType ? 'Update Invoice Type' : 'Add Invoice Type'}</h2>
                    {!isPage && <button className="modal-close" onClick={onClose}>&times;</button>}
                </div>
                <div className="invoice-name-form-body">
                    <form onSubmit={handleSubmit}>
                        <div className="invoice-name-grid">
                            {userRole === 'SUPER_ADMIN' && (
                                <div className="invoice-name-field">
                                    <label>SELECT COMPANY</label>
                                    <select
                                        value={companyId}
                                        onChange={(e) => setCompanyId(e.target.value)}
                                        required
                                        style={{ width: '100%', height: '35px', borderRadius: '4px', border: '1px solid #ccc' }}
                                    >
                                        <option value="">Select Company</option>
                                        <option value="all">All</option>
                                        {companies.map(comp => (
                                            <option key={comp._id || comp.id} value={comp._id || comp.id}>
                                                {comp.companyName || comp.name || comp.company_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            <div className="invoice-name-field">
                                <label>INVOICE TYPE NAME</label>
                                <input
                                    type="text"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder="Enter type name"
                                    required
                                    style={{ width: '100%', height: '35px', borderRadius: '4px', border: '1px solid #ccc', padding: '0 10px' }}
                                />
                            </div>
                        </div>

                        <div className="invoice-name-form-actions" style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
                            <button type="submit" className="list-page-btn list-page-btn-add">Submit</button>
                            <button type="button" className="list-page-btn" style={{ backgroundColor: '#6b7280', color: '#fff' }} onClick={onClose}>Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default InvoiceTypeForm;
